import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth/auth-service';

export const powerUserGroupGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isPoweruser()) {
    return true;
  } else {
    router.navigate(['/unauthorized']);
    return false;
  }
};
